// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editDescriptionDialog {\r\n  position: relative;\r\n  z-index: 300;\r\n  width: 320px;\r\n  -webkit-transition: all 300ms linear;\r\n  transition: all 300ms linear;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
